/**
 * Is used to make object checkable by ngModel
 */
export type Checkable<T> = T & {
    checked?: boolean;
};

/**
 * Converts enum into array of keys
 *
 * @param obj<enum>
 *
 * @return Array<keyof T>
 */
export function EnumKeys<T>(obj: T): Array<keyof T> {
    return (Object.keys(obj) as Array<keyof T>).filter(value => isNaN(Number(value)) !== false);
}
